// extracted by mini-css-extract-plugin
module.exports = {"container":"footer-module--container--owimY","icons":"footer-module--icons--3Dx2w"};